"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "@/components/ui/Link";
import { FaRegBookmark, FaRegCommentDots } from "react-icons/fa";
import FourIconBar from "../ui/MessagePrint";
import PremiumBadge from "../ui/PremiumBadge";
import ImageWithText from "../ui/imagewithtext";
import { ImageMetadata } from '@/lib/componentutills';
import SocialIcons from "@/components/header/SocialIcons";
import Publishon from "@/components/ui/publishon";
import MessagePrint from "../ui/MessagePrint";
import { MessageIconLogo } from "../ui/message-icon-logo";
import ArticleShareButtons from "@/components/component_unique/ArticleShareButtons";
type Props = {
  category?: string;
  sectionUrl?: string;
  title?: string;
  excerpt?: string;
  imageSrc?: string;
  imageCaption?: string;
  imageAttribution?: string;
  imageMetadata?: ImageMetadata;
  publishedAt?: string;
  updatedAt?: string;
  showPublished?: boolean;
  slug?: string;
  articleUrl?: string;
};
export default function BigNewsWithicon(t0) {
  const $ = _c(43);
  const {
    category: t1,
    sectionUrl,
    title: t2,
    excerpt: t3,
    imageSrc: t4,
    imageCaption,
    imageAttribution,
    imageMetadata,
    publishedAt,
    updatedAt,
    showPublished: t5,
    slug,
    articleUrl
  } = t0;
  const category = t1 === undefined ? "INDIA" : t1;
  const title = t2 === undefined ? "\"\u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BB5\u0BBF\u0BAA\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0BA3\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1 \u0B95\u0BCB\u0BB3\u0BBE\u0BB1\u0BC7 \u0B95\u0BBE\u0BB0\u0BA3\u0BAE\u0BCD...\"- \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD\u0BB5\u0BC7 \u0B85\u0BAE\u0BC8\u0B9A\u0BCD\u0B9A\u0BB0\u0BCD \u0BA4\u0B95\u0BB5\u0BB2\u0BCD..!" : t2;
  const excerpt = t3 === undefined ? "\u0BAE\u0BC7\u0BB1\u0BCD\u0B95\u0BC1\u0BB5\u0B99\u0BCD\u0B95 \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BB7\u0BBE\u0BB2\u0BBF\u0BAE\u0BB0\u0BBF\u0BB2\u0BCD \u0B87\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0B9A\u0BC6\u0BA9\u0BCD\u0BA9\u0BC8 \u0BA8\u0BCB\u0B95\u0BCD\u0B95\u0BBF \u0BB5\u0BA8\u0BCD\u0BA4 \u0B95\u0BCB\u0BB0\u0BAE\u0BA3\u0BCD\u0B9F\u0BB2\u0BCD \u0BB5\u0BBF\u0BB0\u0BC8\u0BB5\u0BC1 \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD, \u0B92\u0B9F\u0BBF\u0B9A\u0BBE \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BAA\u0BBE\u0BB2\u0B9A\u0BCB\u0BB0\u0BCD \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BA8\u0BBF\u0BB2\u0BC8\u0BAF\u0BAE\u0BCD \u0B85\u0BB0\u0BC1\u0B95\u0BC7 \u0B9A\u0BC6\u0BA9\u0BCD\u0BB1 \u0B9A\u0BBF\u0BB2 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD \u0B95\u0BCB\u0BB0\u0BAE\u0BA3\u0BCD\u0B9F\u0BB2\u0BCD \u0BB5\u0BBF\u0BB0\u0BC8\u0BB5\u0BC1 \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD, \u0B92\u0B9F\u0BBF\u0B9A\u0BBE \u0BAE\u0BBE\u0BA8\u0BBF\u0BB2\u0BAE\u0BCD \u0BAA\u0BBE\u0BB2\u0B9A\u0BCB\u0BB0\u0BCD \u0BB0\u0BAF\u0BBF\u0BB2\u0BCD \u0BA8\u0BBF\u0BB2\u0BC8\u0BAF\u0BAE\u0BCD \u0B85\u0BB0\u0BC1\u0B95\u0BC7 \u0B9A\u0BC6\u0BA9\u0BCD\u0BB1 \u0B9A\u0BBF\u0BB2 " : t3;
  const imageSrc = t4 === undefined ? "https://media.dinamani.com/dinamani/2025-11-17/z8qqpdrb/erd17manu_1711chn_124_3.jpg" : t4;
  const showPublished = t5 === undefined ? true : t5;
  let t6;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <style>{"\n        @media (max-width: 767px) {\n          .bnwi-title { font-size: 20px !important; font-weight: 700 !important; font-family: var(--font-tamil) !important; }\n        }\n      "}</style>;
    $[0] = t6;
  } else {
    t6 = $[0];
  }
  let t7;
  if ($[1] !== category || $[2] !== sectionUrl) {
    t7 = category ? sectionUrl ? <Link href={sectionUrl} className="text-16-tamil-600 text-012061 tracking-wide uppercase hover:underline 1">{category?.trim() === "\u0BB5\u0BBF\u0BB3\u0BAE\u0BCD\u0BAA\u0BB0\u0BA4\u0BBE\u0BB0\u0BB0\u0BCD \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BBF\u0B95\u0BB3\u0BCD" ? "" : category}</Link> : <div className="text-16-tamil-600 text-012061 tracking-wide uppercase">{category}</div> : <div />;
    $[1] = category;
    $[2] = sectionUrl;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  const t8 = `article-${slug || ""}`;
  const t9 = articleUrl || (slug ? `/${slug}` : undefined);
  let t10;
  if ($[4] !== excerpt || $[5] !== imageSrc || $[6] !== slug || $[7] !== t8 || $[8] !== t9 || $[9] !== title) {
    t10 = <div className="flex items-center gap-1 text-4D4D4D"><MessageIconLogo id={t8} variant="message-icon-3" slug={slug} title={title} thumbnailUrl={imageSrc} description={excerpt} articleUrl={t9} /></div>;
    $[4] = excerpt;
    $[5] = imageSrc;
    $[6] = slug;
    $[7] = t8;
    $[8] = t9;
    $[9] = title;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== t10 || $[12] !== t7) {
    t11 = <div className="flex justify-between items-center text-012061 text-16-english-600">{t7}{t10}</div>;
    $[11] = t10;
    $[12] = t7;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== title) {
    t12 = <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4"><h1 className="text-012061 text-32-tamil-700 md:text-16-tamil-700 bnwi-title leading-[1.5] line-clamp-2 tracking-wide flex-1">{title}</h1></div>;
    $[14] = title;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== excerpt) {
    t13 = <h2 className="text-020202 text-18-tamil-400 md:text-12-tamil-400 leading-[1.5] line-clamp-4">{excerpt}</h2>;
    $[16] = excerpt;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t11 || $[19] !== t12 || $[20] !== t13) {
    t14 = <div className="flex flex-col gap-4">{t11}{t12}{t13}</div>;
    $[18] = t11;
    $[19] = t12;
    $[20] = t13;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== imageAttribution || $[23] !== imageCaption || $[24] !== imageMetadata || $[25] !== imageSrc) {
    t15 = imageSrc && <><ImageWithText text="" imageSrc={imageSrc} imageMetadata={imageMetadata} fixedHeight={true} />{(imageCaption || imageAttribution) && <div className="p-2 text-12-tamil-400 sm:text-16-tamil-400"><p>{imageCaption && <span className="text-black">{imageCaption}</span>}{imageCaption && imageAttribution && " - "}{imageAttribution && <span style={{
            color: "#00000099"
          }}>{imageAttribution}</span>}</p></div>}</>;
    $[22] = imageAttribution;
    $[23] = imageCaption;
    $[24] = imageMetadata;
    $[25] = imageSrc;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  const t16 = publishedAt || "08 May 2023 , 10:30 AM";
  const t17 = updatedAt || "08 May 2023 , 10:30 AM";
  let t18;
  if ($[27] !== showPublished || $[28] !== t16 || $[29] !== t17) {
    t18 = <div className="w-full sm:w-auto text-11-tamil-300 text-1B1B1B line-clamp-1"><Publishon publishedOn={t16} updatedOn={t17} showPublished={showPublished} /></div>;
    $[27] = showPublished;
    $[28] = t16;
    $[29] = t17;
    $[30] = t18;
  } else {
    t18 = $[30];
  }
  const t19 = slug || "";
  let t20;
  if ($[31] !== t19 || $[32] !== title) {
    t20 = <div className="w-full sm:w-auto"><ArticleShareButtons slug={t19} title={title} className="!p-0 !gap-1" /></div>;
    $[31] = t19;
    $[32] = title;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== t18 || $[35] !== t20) {
    t21 = <div className="mt-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">{t18}{t20}</div>;
    $[34] = t18;
    $[35] = t20;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t15 || $[38] !== t21) {
    t22 = <div className="w-full">{t15}{t21}</div>;
    $[37] = t15;
    $[38] = t21;
    $[39] = t22;
  } else {
    t22 = $[39];
  }
  let t23;
  if ($[40] !== t14 || $[41] !== t22) {
    t23 = <article className="flex flex-col overflow-hidden p-4 gap-4">{t6}{t14}{t22}</article>;
    $[40] = t14;
    $[41] = t22;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  return t23;
}